import { AbstractModel } from "./abstract-model";

export class EstimativaAcesso extends AbstractModel{
    ramoAtividade: string;
    rotina: string;
    qtde: number;
    tempo: number;
    categoria: string;
    origem: string;
}